module.exports = __webpack_public_path__ + "static/media/roboto-cyrillic-400-normal.8bb64952.woff2";